<div class="col-md-12 col-sm-12 mt-1">
  <div class="card-content col-md-12 col-sm-12 mt-1">
    <div class="d-flex" style="justify-content: space-evenly" *ngIf="logoEntidade">
      <img [src]="logoEntidade" alt="Logo" style="width: 150px" />
    </div>
    <!-- *ngIf="formEntidadeSomenteLeitura" -->
    <div class="mb-1">
      <h4 class="col-12 text-center titulo p-1 mt-1" style="background: black; color: #fff; border-radius: 10px">
        FORMULÁRIO DE INSCRIÇÃO DA ENTIDADE - {{ nomeEntidade }}
      </h4>
    </div>
    <form [formGroup]="formularioInscricaoEntidadeABJE">
      <div class="col-12">
        <div class="form-group row">
          <!-- N Sócio -->
          <div class="form-group col-sm-12 col-md-6">
            <label for="memberNumber">N Sócio</label>
            <input
              type="text"
              class="form-control round"
              id="memberNumber"
              formControlName="memberNumber"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('memberNumber')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('memberNumber')?.touched
              }" />
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="memberNumber"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Data Ingresso -->
          <div class="col-12 col-sm-12 mb-2 col-md-6">
            <label for="admissionDate">Data Ingresso</label>
            <div class="input-group">
              <input
                #datepickerAdmissionDate="bsDatepicker"
                bsDatepicker
                name="admissionDate"
                maxlength="10"
                type="text"
                class="form-control round bg-white"
                id="admissionDate"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [bsConfig]="bsConfig"
                formControlName="admissionDate"
                [ngClass]="{
                  'is-invalid': formularioInscricaoEntidadeABJE.controls['admissionDate'].errors && isFormSubmited
                }"
                (focus)="campoDataSelecionado($event, 'admissionDate')"
                (ngModelChange)="formatarCampoData($event, 'admissionDate')"
                (onShown)="esconderCalendario()" />

              <div *ngIf="!formEntidadeSomenteLeitura" class="input-group-append">
                <button
                  class="btn btn-secondary round botao-calendario"
                  type="button"
                  (click)="mostrarCalendario('admissionDate')">
                  <i class="fa fa-calendar"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- Seção de Dados Cadastrais -->

          <h4 class="form-section col-12 col-sm-12 col-md-12 mt-2">
            <i class="ft-user"></i>
            <b>Titular Dados Pessoais</b>
          </h4>

          <!-- Nome -->
          <div class="form-group col-sm-12 col-md-8">
            <label for="name">Nome</label>
            <input
              type="text"
              (ngModelChange)="onFieldChange()"
              class="form-control round"
              id="name"
              formControlName="name"
              [ngClass]="{
                'is-invalid': formularioInscricaoEntidadeABJE.controls['name'].errors && isFormSubmited
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="name"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            <div
              class="errorsName"
              *ngIf="
                formularioInscricaoEntidadeABJE.get('name')?.invalid &&
                (formularioInscricaoEntidadeABJE.get('name')?.touched ||
                  formularioInscricaoEntidadeABJE.get('name')?.dirty)
              ">
              <div class="errorsName" *ngIf="formularioInscricaoEntidadeABJE.get('name')?.hasError('checkName')">
                {{ formularioInscricaoEntidadeABJE.get('name')?.errors?.['checkName'] }}
              </div>
            </div>
          </div>
          <!-- CHAPA TRE -->
          <div class="form-group col-sm-12 col-md-4">
            <label for="treBadge">CHAPA TRE</label>
            <input
              type="text"
              class="form-control round"
              id="treBadge"
              formControlName="treBadge"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('treBadge')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('treBadge')?.touched
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="treBadge"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Data de Nascimento -->
          <div class="col-12 col-sm-12 col-md-4">
            <label for="birthDate">Data de Nascimento</label>
            <div class="input-group">
              <input
                #datepickerBirthDate="bsDatepicker"
                bsDatepicker
                name="birthDate"
                maxlength="10"
                type="text"
                class="form-control round bg-white"
                id="birthDate"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [bsConfig]="bsConfig"
                formControlName="birthDate"
                [ngClass]="{
                  'is-invalid': formularioInscricaoEntidadeABJE.controls['birthDate'].errors && isFormSubmited
                }"
                (focus)="campoDataSelecionado($event, 'birthDate')"
                (ngModelChange)="formatarCampoData($event, 'birthDate')"
                (onShown)="esconderCalendario()" />

              <div *ngIf="!formEntidadeSomenteLeitura" class="input-group-append">
                <button
                  class="btn btn-secondary round botao-calendario"
                  type="button"
                  (click)="mostrarCalendario('birthDate')">
                  <i class="fa fa-calendar"></i>
                </button>
              </div>
            </div>
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="birthDate"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Estado Civil -->
          <div class="form-group col-sm-12 col-md-4">
            <label for="civilStatusId">Estado Civil</label>
            <ng-select
              [multiple]="false"
              (ngModelChange)="onFieldChange()"
              [loading]="false"
              [closeOnSelect]="true"
              [searchable]="true"
              class="round shadow"
              formControlName="civilStatusId"
              [ngClass]="{
                'campo-obrigatorio': formularioInscricaoEntidadeABJE.controls['civilStatusId'].errors && isFormSubmited
              }"
              notFoundText="Nenhum registro localizado">
              <ng-option *ngFor="let estadoCivil of listaEstatusCivil" [value]="estadoCivil.id">
                {{ estadoCivil.name }}
              </ng-option>
            </ng-select>
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="civilStatusId"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Sexo -->
          <div class="form-group col-sm-12 col-md-4">
            <label for="sex">Sexo</label>
            <br />

            <input
              [ngClass]="{
                'is-invalid': formularioInscricaoEntidadeABJE.controls['sex'].errors && isFormSubmited
              }"
              (ngModelChange)="onFieldChange()"
              formControlName="sex"
              [value]="1"
              id="active"
              type="radio"
              class="me-2"
              name="sex"
              checked />
            <label class="mb-0">Masculino</label>

            <input
              [ngClass]="{
                'is-invalid': formularioInscricaoEntidadeABJE.controls['sex'].errors && isFormSubmited
              }"
              (ngModelChange)="onFieldChange()"
              formControlName="sex"
              [value]="2"
              id="Inactive"
              type="radio"
              class="me-2"
              name="sex" />
            <label class="mb-0">Feminino</label>

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="sex"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- RG -->
          <div class="form-group col-sm-12 col-md-6">
            <label for="rg">RG</label>
            <input
              name="rg "
              [showMaskTyped]="true"
              (ngModelChange)="onFieldChange()"
              mask="AA.AAA.AAA-A"
              formControlName="rg"
              class="form-control border-radius"
              [ngClass]="{
                'is-invalid': formularioInscricaoEntidadeABJE.controls['rg'].errors && isFormSubmited
              }"
              id="rg" />
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="rg"
              [maxLength]="12"
              [minLength]="10"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- CPF -->
          <div class="form-group col-sm-12 col-md-6">
            <label for="cpf">CPF</label>
            <input
              name="cpf"
              (ngModelChange)="onFieldChange()"
              [showMaskTyped]="true"
              mask="000.000.000-00"
              formControlName="cpf"
              class="form-control border-radius"
              [ngClass]="{
                'is-invalid': formularioInscricaoEntidadeABJE.controls['cpf'].errors && isFormSubmited
              }"
              id="cpf" />
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="cpf"
              [maxLength]="250"
              [minLength]="10"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Nome da Mãe-->
          <div class="form-group col-sm-12 col-md-12">
            <label for="motherName">Nome da Mãe</label>
            <input
              type="text"
              class="form-control round"
              id="motherName"
              formControlName="motherName"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('motherName')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('motherName')?.touched
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="motherName"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Nome do Pai-->
          <div class="form-group col-sm-12 col-md-12">
            <label for="fatherName">Nome do Pai</label>
            <input
              type="text"
              class="form-control round"
              id="fatherName"
              formControlName="fatherName"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('fatherName')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('fatherName')?.touched
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="fatherName"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <div class="col-md-12 col-sm-12 mt-1">
            <!-- Dados de Endereço -->
            <app-endereco
              [estaAberto]="true"
              [ocultarNumero]="true"
              [ocultarComplemento]="true"
              [estaAberto]="true"
              [ocultarBtnAcao]="true"
              [numeroObrigatorio]="false"
              [ocultarTabela]="true"></app-endereco>
          </div>
          <!-- Telefone Residencial-->
          <div class="form-group col-md-4 col-sm-12">
            <label for="homePhone">Telefone Residencial</label>
            <input
              mask="(00) 0000-0000"
              [showMaskTyped]="true"
              class="round form-control"
              formControlName="homePhone"
              [ngClass]="{
                'is-invalid': formularioInscricaoEntidadeABJE.controls['homePhone'].errors && isFormSubmited
              }"
              type="text" />
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="homePhone"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Celular -->
          <div class="form-group col-md-4 col-sm-12">
            <label for="mobilePhone">Celular</label>
            <input
              mask="(00) 00000-0000"
              [showMaskTyped]="true"
              (ngModelChange)="onFieldChange()"
              class="round box-shadow-4 form-control"
              formControlName="mobilePhone"
              type="text"
              [ngClass]="{
                'is-invalid': formularioInscricaoEntidadeABJE.controls['mobilePhone'].errors && isFormSubmited
              }" />
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="mobilePhone"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- E-mail -->
          <div class="form-group mb-1 col-sm-12 col-md-12">
            <label for="email">E-mail Pessoal</label>
            <input
              type="text"
              class="form-control round"
              (ngModelChange)="onFieldChange()"
              id="email"
              formControlName="email"
              [maxlength]="249"
              [ngClass]="{
                'is-invalid': formularioInscricaoEntidadeABJE.controls['email'].errors && isFormSubmited
              }" />
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="email"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            <div
              class="errors"
              *ngIf="
                formularioInscricaoEntidadeABJE.get('email')?.invalid &&
                (formularioInscricaoEntidadeABJE.get('email')?.touched ||
                  formularioInscricaoEntidadeABJE.get('email')?.dirty)
              ">
              <div class="errors" *ngIf="formularioInscricaoEntidadeABJE.get('email')?.hasError('checkEmail')">
                {{ formularioInscricaoEntidadeABJE.get('email')?.errors?.['checkEmail'] }}
              </div>
            </div>
          </div>

          <h4 class="form-section col-12 col-sm-12 col-md-12 mt-2">
            <i class="ft-user"></i>
            <b>Dados Funcionais</b>
          </h4>

          <!-- Do Quadro (number)-->
          <div class="form-group col-sm-12 col-md-4">
            <label for="boardStatus">Do Quadro</label>
            <ng-select
              [multiple]="false"
              [loading]="false"
              [closeOnSelect]="true"
              [searchable]="true"
              class="round shadow"
              formControlName="boardStatus"
              [ngClass]="{
                'is-invalid': formularioInscricaoEntidadeABJE.controls['boardStatus'].errors && isFormSubmited
              }"
              notFoundText="Nenhum registro localizado">
              <ng-option *ngFor="let item of listaDoQuadro" [value]="item.valor">{{ item.nome }}</ng-option>
            </ng-select>
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="boardStatus"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Cargo -->
          <div class="form-group col-sm-12 col-md-4">
            <label for="position">Cargo</label>
            <input
              type="text"
              class="form-control round"
              id="position"
              formControlName="position"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('position')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('position')?.touched
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="position"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Função Comissionada -->
          <div class="form-group col-sm-12 col-md-4">
            <label for="commissionedRole">Função Comissionada</label>
            <input
              type="text"
              class="form-control round"
              id="commissionedRole"
              formControlName="commissionedRole"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('commissionedRole')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('commissionedRole')?.touched
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="commissionedRole"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Início Exercício -->
          <div class="form-group col-sm-12 col-md-4">
            <label for="exerciseStartDate">Início Exercício</label>
            <div class="input-group">
              <input
                #datepickerExerciseStartDate="bsDatepicker"
                bsDatepicker
                name="exerciseStartDate"
                maxlength="10"
                type="text"
                class="form-control round bg-white"
                id="exerciseStartDate"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [bsConfig]="bsConfig"
                formControlName="exerciseStartDate"
                [ngClass]="{
                  'is-invalid': formularioInscricaoEntidadeABJE.controls['exerciseStartDate'].errors && isFormSubmited
                }"
                (focus)="campoDataSelecionado($event, 'exerciseStartDate')"
                (ngModelChange)="formatarCampoData($event, 'exerciseStartDate')"
                (onShown)="esconderCalendario()" />

              <div *ngIf="!formEntidadeSomenteLeitura" class="input-group-append">
                <button
                  class="btn btn-secondary round botao-calendario"
                  type="button"
                  (click)="mostrarCalendario('exerciseStartDate')">
                  <i class="fa fa-calendar"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- Lotação -->
          <div class="form-group col-sm-12 col-md-4">
            <label for="workUnit">Lotação</label>
            <input
              type="text"
              class="form-control round"
              id="workUnit"
              formControlName="workUnit"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('workUnit')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('workUnit')?.touched
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="workUnit"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Prédio do Tre/Andar -->
          <div class="form-group col-sm-12 col-md-4">
            <label for="treBuildingFloor">Prédio do Tre/Andar</label>
            <input
              type="text"
              class="form-control round"
              id="treBuildingFloor"
              formControlName="treBuildingFloor"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('treBuildingFloor')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('treBuildingFloor')?.touched
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="treBuildingFloor"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Telefone/Ramal -->
          <div class="form-group col-md-4 col-sm-12">
            <label for="workPhone">Telefone/Ramal</label>
            <input
              mask="(00) 0000-0000"
              [showMaskTyped]="true"
              class="round form-control"
              formControlName="workPhone"
              [ngClass]="{
                'is-invalid': formularioInscricaoEntidadeABJE.controls['workPhone'].errors && isFormSubmited
              }"
              type="text" />
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="workPhone"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Envio de Correspondências -->

          <h4 class="form-section col-12 col-sm-12 col-md-12 mt-2">
            <i class="ft-user"></i>
            <b>Envio de Correspondências</b>
          </h4>

          <!-- Opção Para Envio de Correspondências -->
          <div class="form-group col-sm-12 col-md-4">
            <label for="correspondenceOption">Opção Para Envio de Correspondências</label>
            <ng-select
              [multiple]="false"
              [loading]="false"
              [closeOnSelect]="true"
              [searchable]="true"
              class="round shadow"
              formControlName="correspondenceOption"
              [ngClass]="{
                'is-invalid': formularioInscricaoEntidadeABJE.controls['correspondenceOption'].errors && isFormSubmited
              }"
              notFoundText="Nenhum registro localizado">
              <ng-option *ngFor="let item of listaEnvioCorrespondencia" [value]="item.valor">
                {{ item.nome }}
              </ng-option>
            </ng-select>
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="correspondenceOption"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- >Deseja receber e-mail -->
          <div class="form-group col-sm-12 col-md-8 text-center">
            <label for="receiveMarketingEmails">Deseja receber e-mail de divulgação de eventos e informes</label>
            <br />
            <div class="row justify-content-center">
              <div class="col-md-4">
                <input
                  [ngClass]="{
                    'is-invalid':
                      formularioInscricaoEntidadeABJE.controls['receiveMarketingEmails'].errors && isFormSubmited
                  }"
                  formControlName="receiveMarketingEmails"
                  [value]="true"
                  id="active"
                  type="radio"
                  class="me-2"
                  name="receiveMarketingEmails"
                  checked />
                <label class="mb-0">Sim</label>
              </div>
              <div class="col-md-4">
                <input
                  [ngClass]="{
                    'is-invalid':
                      formularioInscricaoEntidadeABJE.controls['receiveMarketingEmails'].errors && isFormSubmited
                  }"
                  formControlName="receiveMarketingEmails"
                  [value]="false"
                  id="Inactive"
                  type="radio"
                  class="me-2"
                  name="receiveMarketingEmails" />
                <label class="mb-0">Não</label>
              </div>
            </div>
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="receiveMarketingEmails"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Autorização de Pagamento para ABJE -->

          <h4 class="form-section col-12 col-sm-12 col-md-12 mt-2">
            <i class="ft-user"></i>
            <b>Autorização de Pagamento para ABJE</b>
          </h4>

          <!-- >Deseja receber e-mail -->
          <div class="form-group col-sm-12 col-md-12 text-center">
            <!-- <label for="sex">Deseja receber e-mail de divulgação de eventos e informes </label> -->
            <br />
            <div class="row alinhamento-debito-mobile" style="justify-content: space-around">
              <div class="row">
                <input
                  [ngClass]="{
                    'is-invalid':
                      formularioInscricaoEntidadeABJE.controls['paymentAuthorization'].errors && isFormSubmited
                  }"
                  formControlName="paymentAuthorization"
                  [value]="0"
                  id="active"
                  type="radio"
                  class="me-2"
                  name="paymentAuthorization"
                  checked />
                <label class="mb-0">Débito em folha de pagamento</label>
              </div>
              <div class="row">
                <input
                  [ngClass]="{
                    'is-invalid':
                      formularioInscricaoEntidadeABJE.controls['paymentAuthorization'].errors && isFormSubmited
                  }"
                  formControlName="paymentAuthorization"
                  [value]="1"
                  id="Inactive"
                  type="radio"
                  class="me-2"
                  name="paymentAuthorization" />
                <label class="mb-0">Débito em conta corrente*</label>
              </div>
            </div>
            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="paymentAuthorization"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <p class="mb-1">*Somente associados que possuem conta no Banco do Brasil.</p>
          <!-- Dados Bancários -->

          <h4 class="form-section col-12 col-sm-12 col-md-12 mt-2">
            <i class="ft-user"></i>
            <b>Dados Bancários</b>
          </h4>

          <!-- Nome do Banco -->
          <div class="form-group col-sm-12 col-md-6">
            <label for="bankName">Nome do Banco</label>
            <input
              type="text"
              class="form-control round"
              id="bankName"
              formControlName="bankName"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('bankName')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('bankName')?.touched
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="bankName"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Nome da Agência -->
          <div class="form-group col-sm-12 col-md-6">
            <label for="agencyName">Nome da Agência</label>
            <input
              type="text"
              class="form-control round"
              id="agencyName"
              formControlName="agencyName"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('agencyName')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('agencyName')?.touched
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="agencyName"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- N° da Agência -->
          <div class="form-group col-sm-12 col-md-6">
            <label for="agencyNumber">N° da Agência</label>
            <input
              type="text"
              class="form-control round"
              id="agencyNumber"
              formControlName="agencyNumber"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('agencyNumber')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('agencyNumber')?.touched
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="agencyNumber"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- N° Conta Corrente -->
          <div class="form-group col-sm-12 col-md-6">
            <label for="currentAccountNumber">N° Conta Corrente</label>
            <input
              type="text"
              class="form-control round"
              id="currentAccountNumber"
              formControlName="currentAccountNumber"
              [ngClass]="{
                'is-invalid':
                  formularioInscricaoEntidadeABJE.get('currentAccountNumber')?.invalid &&
                  formularioInscricaoEntidadeABJE.get('currentAccountNumber')?.touched
              }" />

            <app-validacao-form-input
              [nomeFormulario]="formularioInscricaoEntidadeABJE"
              nomeCampo="currentAccountNumber"
              [maxLength]="250"
              [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
          </div>
          <!-- Produtos -->
          <h4 class="form-section col-12 col-sm-12 col-md-12 mt-2">
            <i class="ft-user"></i>
            <b>Produtos</b>
          </h4>
          <!-- Tabela Produtos -->
          <div class="table-responsive">
            <div id="users-contacts_wrapper" class="dataTables_wrapper dt-bootstrap4">
              <div class="row">
                <div class="col-sm-12">
                  <table
                    id="users-contacts"
                    class="table table-middle dataTable w-100"
                    role="grid"
                    aria-describedby="users-contacts_info">
                    <thead class="bg-table-geia white">
                      <tr>
                        <th class="text-center" style="width: 10%">Opção</th>
                        <th class="text-center" style="width: 30%">Produto</th>
                        <th class="text-center" style="width: 60%">Anuidade</th>
                      </tr>
                    </thead>
                    <tbody *ngFor="let item of listaProduto">
                      <tr>
                        <td class="text-center align-middle">
                          <div class="d-flex justify-content-center">
                            <label class="checkbox-container">
                              <input
                                [checked]="item.valor === true"
                                (change)="selecionarProduto(item)"
                                type="radio"
                                class="hidden-checkbox"
                                name="produtoEscolhido"
                                [disabled]="true" />
                              <span class="checkmark"></span>
                            </label>
                          </div>
                        </td>
                        <td class="text-wrap align-middle">
                          <span class="font-weight-bold">{{ item.produto }}</span>
                        </td>
                        <td class="text-wrap align-middle">
                          <span class="font-weight-bold">{{ item.anuidade }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- Botão de Confirmação -->
    <div *ngIf="!formEntidadeSomenteLeitura" class="modal-footer d-flex" style="border: none">
      <div class="col-12 text-right">
        <button type="button" class="btn mr-2 btn-success round box-shadow-4" (click)="salvar()">
          <i class="ft-thumbs-up"></i>
          Confirmar
        </button>
        <button (click)="fechar()" type="button" class="btn btn-warning round box-shadow-4">
          <i class="ft-thumbs-down"></i>
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>
